import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import Image from "components/ui/image"
import { cn } from "styles/utils"

import ItemContainer from "./item-container"

const Placeholder = ({ dataCy, index }) => {
  const collectionReviewExp = useSelector(
    (state) => state.experiment.collectionReview.variant_id
  )

  return (
    <ItemContainer data-cy={dataCy}>
      <Image
        alt=""
        className={cn(
          "shimmer mx-auto h-auto w-full max-w-full",
          collectionReviewExp !== 1 && "tablet:max-w-256 widescreen:max-w-300"
        )}
        height="1024"
        src={require(
          `images/collections/placeholder_masks/ring_${(index % 6) + 1}.svg`
        )}
        width="1024"
      />
    </ItemContainer>
  )
}

Placeholder.propTypes = {
  dataCy: PropTypes.string,
  index: PropTypes.number,
}

export default Placeholder
